import type { DeepDive } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (deepDives?: DeepDive[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description: 'Available deep dives the user can explore and enroll in',
    data: deepDives ?? [],
  });
};
